import React, { useEffect, useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import allreportsdata from "../../../json-data/allreports.json";
import allReportsHindidata from "../../../json-data/allReportsHindi.json";
import { fetchArchiveServicesStudentGPIStatsData } from "../../../redux/thunks/archiveServicesThunk";
import { useExportToExcel } from "../../../pdfAndExcellUtils/pdfAndExcellUtils";

import {
  initialFilterEnrolmentSummarisedData,
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  district,
  districtWiseName,
  blockWiseName,
  block,
  generateTextContent,
  foundational_preparatory,
  middle,
  secondary,
  excelStyles
} from "../../../constants/constants";

import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { columnsConfigFor4032 } from "../../../constants/constants";

import "../infra.css";
import "../report.scss";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { useLocation } from "react-router-dom";
import { GlobalLoading } from "../../GlobalLoading/GlobalLoading";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../../Home/filter/FilterDropdownCommon358";
import { removeAllDistrict } from "../../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../../redux/slice/headerSlice";
import { handleMissingData } from "../../../utils/handleMissingData";
import satyamevaimg from "../../../assets/images/satyameva-jayate-img.png";
import udise from "../../../assets/images/udiseplu.jpg";
import nic from "../../../assets/images/nic-sm-logo.png";
import {
  TeacherGraph2008,
  TeacherGraph2009,
  TeacherGraph2010,
} from "../TeacherGraph2008";
import { ScrollToTopOnMount } from "../../Scroll/ScrollToTopOnMount";
import { Result } from "antd";

import useReportOverallRegionSum from "../../../CustomHook/useReportOverallRegionSum";
import Footer from "../../Header/Footer";
import HighchartsReact from "highcharts-react-official";
import { BarChart } from "../TeacherReport/TeacherGraph2005";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
export default function EnrolmentReport4032() {
  const dispatch = useDispatch();
  const location = useLocation();
  const schData = useSelector((state) => state.enrolmentStudentGPI);
  const school_datas = useSelector((state) => state.enrolmentStudentGPI?.data?.data);
  ////console.log('school_datas', school_datas)
  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  const schoolFilter = useSelector((state) => state.schoolFilter);
  const filterObj = structuredClone(schoolFilter);
  const headerData = useSelector((state) => state.header);
  const local_year = window.localStorage.getItem("year");
  const stateName = localStorage.getItem("state");
  const [groupKeys, setGroupKeys] = useState({
    schManagementBroad: false,
    schMgmtCenterIdDesc: false,
    schCategoryBroad: false,
    schCategoryIdDesc: false,
    schLocURDesc: false,
  });

  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("map_state_name"));
    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [mgt, setMgt] = useState("");
  const [mgt_Details, setMgtDetail] = useState("");
  const [cat, setCat] = useState("");
  const [cat_Details, setCatDetail] = useState("");
  const [ur, setUR] = useState("");
  const [multiMgt, setMultiMgts] = useState("");
  const [multiCat, setMultiCats] = useState("");
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const [intialStudentData, setIntialStudentData] = useState(school_datas);
  const gridApiRef = useRef(null);
  const [activeTab, setActiveTab] = useState(type);
  const { t, i18n } = useTranslation();
  dispatch(handleActiveTabs(activeTab));
  useEffect(() => {
    setIntialStudentData(school_datas);
  }, [school_datas]);

  // Taking the both reports data condition wise for language change
  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  useEffect(() => {
    dispatch(allFilter(initialFilterEnrolmentSummarisedData));
    dispatch(
      fetchArchiveServicesStudentGPIStatsData(initialFilterEnrolmentSummarisedData)
    );
  }, [dispatch]);
  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [arrGroupedGraphData, setArrGroupedGraphData] = useState([]);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const filter_query_by_location =
    // local_state === "All India/National" ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";

  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },

    {
      headerName: "Location",
      field: "regionName",
      hide: !filter_query_by_location,
    },
    {
      headerNameKey: "Foundational",
      field: "priT",
      hide: false,
    },
    {
      headerNameKey: "Preparatory",
      field: "upriT",
      hide: false,
    },
    {
      headerNameKey: "Middle",
      field : "secT",
      hide: false,
    },
    // {
    //   headerNameKey: "Elementry(1-8)",
    //   field: "elemT",
    //   hide: false,
    // },
    {
      headerNameKey: "Secondary",
      field: "hsecT",
      hide: false,
    },
    
  ]);

  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    // filter: true,
    autoHeaderHeight: true,
    headerClass: "headerStyle",
  });

  function onColumnVisible(event) {
    const columnId = event?.column?.colId;
    const visible = event.visible;
    if (columnId === "schManagementBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schManagementBroad: visible,
      }));
      setMgt(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schMgmtCenterIdDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schMgmtCenterIdDesc: visible,
      }));
      setMgtDetail(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryBroad: visible,
      }));
      setCat(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryIdDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryIdDesc: visible,
      }));
      setCatDetail(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }

    if (columnId === "schLocURDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schLocURDesc: visible,
      }));
      setUR(() => (visible ? "active" : ""));
    }
  }

  const onGridReady = (params) => {
    if (!params) {
      return;
    }
    gridApiRef.current = params?.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys)?.forEach((key) => {
        ////console.log('keyss',key)
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };

  const handleCustomKeyInAPIResponse = () => {
    const arr = [];
    school_datas?.forEach((item, idx) => {
      let appendedObj = { ...item };
      /* broad management key added*/
      ////console.log('item', item)
      if (state_gov_mgt_code.includes(item.schMgmtCenterId)) {
        appendedObj.schManagementBroad = "State Government";
      } else if (gov_aided_mgt_code.includes(item.schMgmtCenterId)) {
        appendedObj.schManagementBroad = "Govt. Aided";
      } else if (pvt_uaided_mgt_code.includes(item.schMgmtCenterId)) {
        appendedObj.schManagementBroad = "Private Unaided";
      } else if (ctrl_gov_mgt_code.includes(item.schMgmtCenterId)) {
        appendedObj.schManagementBroad = "Central Government";
      } else if (other_mgt_code.includes(item.schMgmtCenterId)) {
        appendedObj.schManagementBroad = "Others";
      }
         /* broad category key added*/
         if (foundational_preparatory.includes(item.schCategoryId)) {
          appendedObj.schCategoryBroad = "Foundational and Preparatory";
        } else if (middle.includes(item.schCategoryId)) {
          appendedObj.schCategoryBroad = "Middle";
        } 
        else if (secondary.includes(item.schCategoryId)) {
          appendedObj.schCategoryBroad = "Secondary";
        } 
      arr.push(appendedObj);
    });
    ////console.log('array-original',arr)
    setData(arr);
    ////console.log('dataa',data)
    setGraphData(arr);
  };

  const generateKey = (item, filters) => {
    const {
      regionName
    } = item;
    let keyParts = [regionName];
    return keyParts.join("-");
  };

  const groupData = (data, filters) => {
    const groupedData = {};

    ////console.log('data', data)
    data.forEach((item) => {
      const key = generateKey(item, filters);
        ////console.log('item', item)
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,          
            priT: 0,
            upriT: 0,
            secT: 0,
            hsecT: 0         
          };
        }
        groupedData[key].priT = item.priT;
        groupedData[key].upriT = item.upriT;
        groupedData[key].secT = item.secT;
        groupedData[key].hsecT = item.hsecT;
      
    });

    ////console.log('groupedData', groupedData)
    return Object.values(groupedData);
  };

  const handleButtonClick = (type, detailType) => {
    handleFilterClick(type, detailType);

    if (type === "School Management") {
      setMgt((prevMgt) =>
        detailType === "broad" ? (prevMgt === "active" ? "" : "active") : ""
      );
      setMgtDetail((prevMgtDetail) =>
        detailType === "desc"
          ? prevMgtDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    if (type === "School Category") {
      setCat((prevCat) =>
        detailType === "broad" ? (prevCat === "active" ? "" : "active") : ""
      );
      setCatDetail((prevCatDetail) =>
        detailType === "desc"
          ? prevCatDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }
  };

  useEffect(() => {
    setColumn((prevColumns) => {
      const updatedColumns = [...prevColumns];
      // const firstChild = updatedColumns[1].children[0].children;
      const firstChild =updatedColumns;

      const updateColumnVisibility = (field, isVisible) => {
        const index = firstChild.findIndex((col) => col.field === field);
        if (index !== -1) {
          firstChild[index].hide = !isVisible;
        }
      };

      if (groupKeys.schManagementBroad !== undefined) {
        updateColumnVisibility(
          "schManagementBroad",
          groupKeys.schManagementBroad
        );
      }
      if (groupKeys.schMgmtCenterIdDesc !== undefined) {
        updateColumnVisibility(
          "schMgmtCenterIdDesc",
          groupKeys.schMgmtCenterIdDesc
        );
      }
      if (groupKeys.schCategoryBroad !== undefined) {
        updateColumnVisibility("schCategoryBroad", groupKeys.schCategoryBroad);
      }
      if (groupKeys.schCategoryIdDesc !== undefined) {
        updateColumnVisibility("schCategoryIdDesc", groupKeys.schCategoryIdDesc);
      }
      if (groupKeys.schLocURDesc !== undefined) {
        updateColumnVisibility("schLocURDesc", groupKeys.schLocURDesc);
      }
      updateColumnVisibility("regionName", filter_query_by_location);

      const updatedDefs = updatedColumns.map((colGroup) => ({
        ...colGroup,
        children: colGroup.children?.map((col) => ({
          ...col,
          // hide: firstChild.find((c) => c.field === col.field)?.hide || col.hide,
          hide:false,
          headerClass: "headerStyle",
        })),
      }));

      ////console.log('updatedDefs', updatedDefs)
      return updatedDefs;
    });

    ////console.log('columns ',columns)

    const grouped = groupData(data, groupKeys);
    ////console.log('grouped', grouped)
    setArrGroupedData(grouped);
    setColumnVisibility(groupKeys);
  }, [groupKeys, data, filter_query_by_location, school_datas]);

  // using use effect to translate the data
  useEffect(() => {
    const translateColumns = (columnsArray) => {
      return columnsArray?.map((col) => {
        // Add your condition here
        if (col.headerNameKey === 'School Management(Broad)' || col.headerNameKey === 'School Management(Detailed)' || col.headerNameKey === 'School Category(Broad)'
          || col.headerNameKey === 'School Category(Detailed)' || col.headerNameKey === 'Urban/Rural'
        ) {
          // For example, if the column field is 'price', apply a different translation or logic
          return {
            ...col,
            filter: true,
            headerClass: "headerStyle",
            headerName: t(col.headerNameKey),
            children: col.children ? translateColumns(col.children) : col.children,
            // Any additional modifications specific to 'price' field
            width: 150, // Example: Set width specifically for price column
          };
        }
    else{
      return {
        ...col,
        filter: false,
        headerClass: "headerStyle",
        headerName: t(col.headerNameKey),
        children: col.children ? translateColumns(col.children) : col.children,
      };
    }
        // Default behavior if the condition is not met
   
      });
    };

    const translatedColumns = translateColumns(columnsConfigFor4032);

    setColumn(translatedColumns);
    ////console.log('columns ',columns)
  }, [t]);

  const handleFilterClick = (type, detailType) => {
    setGroupKeys((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (type === "School Management") {
        if (detailType === "broad") {
          newFilters.schManagementBroad = !prevFilters.schManagementBroad;
          newFilters.schMgmtCenterIdDesc = false;
        } else if (detailType === "desc") {
          newFilters.schMgmtCenterIdDesc = !prevFilters.schMgmtCenterIdDesc;
          newFilters.schManagementBroad = false;
        }
      } else if (type === "School Category") {
        if (detailType === "broad") {
          newFilters.schCategoryBroad = !prevFilters.schCategoryBroad;
          newFilters.schCategoryIdDesc = false;
        } else if (detailType === "desc") {
          // newFilters.schCategoryIdDesc = !prevFilters.schCategoryIdDesc;
          // newFilters.schCategoryBroad = false;
        }
      } else if (type === "Urban/Rural") {
        newFilters.schLocURDesc = !prevFilters.schLocURDesc;
      }

      return newFilters;
    });
  };

  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };
  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => parseFloat(total + parseFloat(row[fieldName] || 0)).toFixed(2),
      0
    );
  }

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Total" }
        : { regionName: "Total" }),
      
      priT: calculateTotal("priT"),
      upriT: calculateTotal("upriT"),
      secT: calculateTotal("secT"),
      hsecT: calculateTotal("hsecT"),
      // Correct total calculation
      total:
        
        calculateTotal("priT") +
        calculateTotal("upriT") +
        calculateTotal("secT") +
        calculateTotal("hsecT")
    },
  ];

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
  
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns?.map((column) => {
      const { field, headerName } = column?.getColDef();
      const sort = column?.getSort();
      const headerNameUppercase = field[0]?.toUpperCase() + field?.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
  
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi?.api?.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      if (!columns) {
        return;
      }
      columns?.forEach((column) => {
        rowToExport?.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const headerRow = getHeaderToExport(gridApi);
    ////console.log('headerRow', headerRow)
    const rows = getRowsToExport(gridApi);
    const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
    const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
    ? (pinedBottomRowDatas)
    : [];
    const pinnedBottomRow = pinnedBottomRowData
    const date = new Date();
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    if (pinnedBottomRow && pinnedBottomRow.length > 0) {
      pinnedBottomRow.forEach((row) => {
        const totalRow = headerRow.map((header) => {
          let field = header.text;
          if (row.hasOwnProperty(field.charAt(0).toLowerCase() + field.slice(1))) {
            field = field.charAt(0).toLowerCase() + field.slice(1);
          } else if (row.hasOwnProperty(field.charAt(0).toUpperCase() + field.slice(1))) {
            field = field.charAt(0).toUpperCase() + field.slice(1);
          }
          return row[field] !== undefined ? row[field].toString() : "";
        });
    
        table.push(totalRow);
      });
    }
    const headers = [];
    // First row: Social Category spanning all columns
    headers.push([
      {
        content: "",
        colSpan: table[0].length,
        styles: { halign: "center" },
      },
    ]);

    // Second row: Category headers
    const secondRow = [
      { content: "", colSpan: 1, styles: { halign: "center" } },
    ];
    const visibleFields = gridApi.api.getAllDisplayedColumns().map(col => col.getColDef().field);

    // Filter only visible group headers
        const visibleGroups = columns[2].children.filter(group =>
          group.children.some(child => visibleFields.includes(child.field))
        );
    
    visibleGroups.forEach((category) => {
      secondRow.push({
        content: category.headerName,
        colSpan: category.children.length,
        styles: { halign: "center" },
      });
    });

    // const numberOfColumns = table[0].length;
    // const baseValue = 10;
    // const extraCells = numberOfColumns - baseValue;

    let extraCells = 0;
    for(let i = 0 ; i < table[0].length; i++){
      if(table[0][i] === "Location"  || table[0][i] === "School Management(Broad)"  || table[0][i] === "School Management(Detailed)" || table[0][i] === "School Category(Broad)" || table[0][i] === "School Category(Detailed)" || table[0][i] === "Urban/Rural"){
        extraCells++;
      }
    }
    
    // Add empty cells to the start of secondRow
    if (extraCells > 0) {
      for (let i = 0; i < extraCells; i++) {
        secondRow.unshift({ content: "", colSpan: 1 });
      }
    }

    const thirdRow = [{ content: "", styles: { halign: "center" } }];
    table[0].forEach((header) => {
      thirdRow.push({ content: header, styles: { halign: "center" } });
    });
    thirdRow.shift();
    headers.push(secondRow);
    headers.push(thirdRow);

    addHeader();
    doc.autoTable({
      head: headers,
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
        halign: "center",
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;
        const columnHeaderHeaderName = headerRow[data.column.index]?.headerName;
        // Check if the current column header is "Serial Number"
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center";
        } else if (
          columnHeaderText === "RegionName" ||
          columnHeaderText === "Location"
        ) {
          data.cell.styles.halign = "left";
        } else if (
          columnHeaderText === "SchManagementBroad" ||
          columnHeaderText === "SchCategoryBroad" ||
          columnHeaderText === "SchTypeDesc" ||
          columnHeaderText === "schLocURDesc" ||
          columnHeaderText === "schMgmtCenterIdDesc" ||
          columnHeaderText === "schMgmtCenterIdDesc" ||
          columnHeaderText === "schCategoryIdDesc"
        ) {
          data.cell.styles.halign = "left";
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();
    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }
    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    if (!gridApi) {
      return;
    }
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };
    const { exportToExcel } = useExportToExcel(gridApi, report, local_year, stateName, nationalWiseName, stateWiseName, local_district, district, districtWiseName, local_block, block, blockWiseName, generateTextContent);

  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      if (!gridApi) {
        return;
      }
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };
  useEffect(() => {
    if (intialStudentData && intialStudentData.length > 0) {
      handleCustomKeyInAPIResponse();
    }
  }, [intialStudentData, school_datas, location.pathname]);
  //  ........................Graph code statr here.....................
  // ...Start Total No. of Teacher by School Management & School Category.....
  const generateKeyGraph = (item, filters) => {
    const { regionName } = item;
    let keyParts = [regionName];
    return keyParts.join("-");
  };

  const groupGraphData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      ////console.log('item', item)
      const key = generateKeyGraph(item, filters);
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            priT: 0,
            upriT: 0,
            secT: 0,
            hsecT: 0
            
          };
        }
  
        groupedData[key].priT = item.priT;
        groupedData[key].upriT = item.upriT;
        groupedData[key].secT = item.secT;
        groupedData[key].hsecT = item.hsecT;
  
        groupedData[key].totalSchCatWise =
          groupedData[key].priT +
          groupedData[key].upriT +
          groupedData[key].secT +
          groupedData[key].hsecT 
     
    });

    ////console.log('groupedData', groupedData)
    return Object.values(groupedData);
  };

  useEffect(() => {
    const grouped = groupGraphData(data, groupKeys);
    setArrGroupedGraphData(grouped);
  }, [groupKeys, graphData, filter_query_by_location, school_datas]);

  //Code For Graph 1

  // Taking Objects for category and management
  const categoryTranslations = {
    "Primary (PRY)": t("categories_school.Primary (PRY)"),
    "Upper Primary (UPR)": t("categories_school.Upper Primary (UPR)"),
    "Higher Secondary (HSEC)": t("categories_school.Higher Secondary (HSEC)"),
    "Secondary (SEC)": t("categories_school.Secondary (SEC)"),
  };

  const managementTranslations = {
    "State Government": t("managements.State Government"),
    "Govt. Aided": t("managements.Govt. Aided"),
    "Private Unaided": t("managements.Private Unaided"),
    "Central Government": t("managements.Central Government"),
    Others: t("managements.Others"),
  };

  // function to translate the data dynamically
  const translateDataKeys = (
    data,
    categoryTranslations,
    managementTranslations
  ) => {
    return data.map((item) => ({
      ...item,
      schCategoryBroad:
        categoryTranslations[item.schCategoryBroad] || item.schCategoryBroad,
      schManagementBroad:
        managementTranslations[item.schManagementBroad] ||
        item.schManagementBroad,
    }));
  };

  const processGraphData = (data) => {
    const translatedData = translateDataKeys(
      data,
      categoryTranslations,
      managementTranslations
    );

    // Define categories and managements in Hindi
    const categories = Object.values(categoryTranslations);
    const managements = [
      { name: managementTranslations["State Government"], color: "#751539" },
      { name: managementTranslations["Govt. Aided"], color: "#E6694A" },
      { name: managementTranslations["Private Unaided"], color: "#F5BF55" },
      { name: managementTranslations["Central Government"], color: "#BCE263" },
      { name: managementTranslations["Others"], color: "#57C1BB" },
    ];
    const abbreviateCategory = (category) => {
      return category.replace(/\s*\([^)]*\)/, "");
    };

    const seriesData = managements.map((management) => ({
      name: management.name,
      data: categories.map((category) => {
        const total = translatedData
          .filter(
            (item) =>
              item.schCategoryBroad === category &&
              item.schManagementBroad === management.name
          )
          .reduce((acc, curr) => acc + curr.totalSchCatWise, 0);
        return total;
      }),
      color: management.color,
    }));

    const abbreviatedCategories = categories.map(abbreviateCategory);

    const abbreviatedSeriesData = seriesData.map((series) => ({
      ...series,
      name: series.name.replace("Government", "Govt."),
    }));

    return {
      categories: abbreviatedCategories,
      series: abbreviatedSeriesData,
    };
  };

  const graphScmSchData = processGraphData(arrGroupedGraphData);

  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesStudentGPIStatsData(initialFilterEnrolmentSummarisedData)
      );
    }
    if (headerData.activeTab === "graph") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesStudentGPIStatsData(initialFilterEnrolmentSummarisedData)
      );
    }
  }, [headerData.activeTab, dispatch]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.

  const arrGroupedDataTable = handleMissingData(arrGroupedData, columns).map(
    (item) => ({
      ...item,
      total:
        item.priT +
        item.upriT +
        item.secT +
        item.hsecT 
    })
  );


  console.log('arrGroupedData', arrGroupedData)
  // const result = useReportOverallRegionSum(arrGroupedDataTable);
  
  const result = arrGroupedDataTable;
  ////console.log('result', result)
  console.log('arrGroupedDataTable', arrGroupedDataTable);
  ////console.log('columns', columns)
  const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
  const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
  ? (  pinedBottomRowDatas)
  : [];
  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      {schData.isLoading && <GlobalLoading />}
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")}
                          {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>

                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {" "}
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {t("download_as_pdf")}{" "}
                          </option>
                          <option value="export_excel">
                            {" "}
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
              {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">
                    {" "}
                    {t("view_data_by")}
                  </div>
                  {/* <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiMgt}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active ${mgt}`}
                        onClick={(e) =>
                          handleButtonClick("School Management", "broad", e)
                        }
                      >
                        {t("school_management_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active details-multi ${mgt_Details}`}
                        id="school_mgt_details"
                        onClick={(e) =>
                          handleButtonClick("School Management", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                    <li className={`nav-item ${multiCat}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active1 ${cat}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "broad", e)
                        }
                      >
                        {t("school_category_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active1 details-multi ${cat_Details}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${ur}`}
                        onClick={(e) =>
                          handleButtonClick("Urban/Rural", "broad", e)
                        }
                      >
                        {t("urban_rural")}
                      </button>
                    </li>
                  </ul> */}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph">
            <div className="row align-items-center report-inner-tab">
              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")} <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}
                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p>The "Gender Parity Index (GPI) of Gross Enrollment Ratio (GER) by Level of Education" is a metric used to assess gender equality in education. It compares the enrollment ratios of male and female students across various levels of education, such as primary, secondary, and higher education. The Gross Enrollment Ratio (GER) represents the total enrollment in a particular level of education, regardless of age, expressed as a percentage of the population that is of official age for that level.<br />

The Gender Parity Index (GPI) is calculated by dividing the GER for female students by the GER for male students. A GPI value of 1 indicates perfect gender parity, meaning that the enrollment ratio for girls is equal to that of boys. If the GPI is greater than 1, it indicates that more girls are enrolled compared to boys, while a GPI of less than 1 shows that fewer girls are enrolled in comparison to boys.<br />

By analyzing the GPI of GER across different levels of education, this data provides valuable insights into how gender disparities vary at various educational stages. For example, at the primary level, there may be relatively balanced enrollment between boys and girls, while at the secondary or higher education levels, gender imbalances may emerge due to societal or economic factors.<br />

This metric is critical for identifying areas where gender disparities persist in education, helping policymakers and educational planners target interventions that promote gender equity. Ensuring that the GPI approaches 1 across all levels of education is a key goal for fostering inclusive education systems where both girls and boys have equal access to educational opportunities.
</p>
                    </div>
                  </Tab> */}
                  <Tab eventKey="table" title={t("table")}>
                    <div className="multi-header-table">
                      <div
                        className=" multi-header-table ag-theme-quartz ag-theme-custom-height h-300"
                        style={{ height: 450 }}
                      >
                        <AgGridReact
                          key={gridRefreshKey}
                          rowData={
                            filter_query_by_location
                              ? result
                              : arrGroupedDataTable
                              ? arrGroupedDataTable
                              : 1
                          }

                          
                        getRowStyle={(params) => {
                          if (params.data.isTotalRow) {
                            return { fontWeight: 'bold' };  // Apply inline bold style for totals row
                          }
                          return {};  // Default style for other rows
                        }}
                          columnDefs={columns}
                          defaultColDef={defColumnDefs}
                          onColumnVisible={onColumnVisible}
                          onGridReady={onGridReady}
                          groupDisplayType="custom"
                          groupHideOpenParents={true}
                          excelStyles={excelStyles}
                          // pinnedBottomRowData={pinnedBottomRowData}
                        />
                      </div>
                    </div>
                  </Tab>
                  <Tab disabled eventKey="graph" title={t("chart")} >
                    <div className="card-box-impact tab-for-graph report-2008 mt-4 tab-content-reduce">
                      <div className="row">
                        <div className="col-md-12 col-lg-12">
                          <div className="piechart-box mt-4">
                            {
                              arrGroupedDataTable.length > 0 &&  <BarChart data = {arrGroupedDataTable} />
                            
                            }
                         </div>
                        </div>

                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FilterDropdownCommom358 />
    </>
  );
}
